import { StyleSheet, View, TouchableOpacity, Image } from "react-native";
import React, { useEffect } from "react";
import BackArrow from "@assets/svg/BackArrow";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { REFER_EARN } from "@constants/analyticsEventsCT";
import Text from "../../components/CustomText";

const PATH = "screens/ReferORScreen";

const ReferQRScreen = ({ navigation, route }) => {
  const {
    params: { referralLink },
  } = route;

  const goBack = () => {
    navigation.goBack();
  };

  useEffect(() => {
    analytics.trackEvent(REFER_EARN.REFER_REFER_NOW, {
      screen: "Refer Side Menu",
      medium: "QR Code",
    });
  }, []);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={goBack}>
          <BackArrow color="#000" />
        </TouchableOpacity>
      </View>
      <View style={styles.content}>
        <Text style={styles.titleText}>{t(`${PATH}/referScan`)}</Text>
        <Text style={styles.subTitleText}>{t(`${PATH}/scanAppDownload`)}</Text>
        <View style={styles.qrCodeContainer}>
          <Image
            source={{ uri: referralLink }}
            style={{ width: 200, height: 200 }}
          />
        </View>
      </View>
    </View>
  );
};

export default ReferQRScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    //
  },
  header: {
    padding: 5,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  backButton: {
    padding: 15,
    borderRadius: 10,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignContent: "center",
  },
  titleText: {
    color: "rgba(0, 0, 0, 0.86)",
    fontSize: 16,
    fontWeight: "700",
    textAlign: "center",
  },
  subTitleText: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: 14,
    fontWeight: "400",
    textAlign: "center",
  },
  qrCodeContainer: {
    alignItems: "center",
    marginTop: 40,
  },
});
